import React,{ useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Breadcrumb from '../Components/Breadcrumb';

const faqs = [
    {
        question: "What services do you offer?",
        answer: "We offer a range of professional services including consulting, design, development, engineering, and more, tailored to meet your business needs."
    },
    {
        question: "How do I get started?",
        answer: "Simply contact us through our website, email, or phone. We'll schedule an initial consultation to discuss your goals and how we can help."
    },
    {
        question: "Do you offer free consultations?",
        answer: "Yes, we offer a 30-minute free consultation to understand your needs and determine how we can best support your business."
    },
    {
        question: "How much do your services cost?",
        answer: "Pricing depends on the scope and complexity of the project. We offer both hourly and flat-rate options. Contact us for a custom quote."
    },
    {
        question: "How long will my project take?",
        answer: "Timelines vary depending on the size and type of project. After the initial consultation, we’ll provide a detailed project timeline."
    },
    {
        question: "Can you work with businesses in different industries?",
        answer: "Absolutely. We’ve worked with clients across various sectors, including healthcare, finance, retail, tech, and more."
    },
    {
        question: "Do you offer ongoing support after project completion?",
        answer: "Yes, we provide ongoing support and maintenance plans to ensure your solution continues to deliver value."
    },
    {
        question: "How do you ensure quality and satisfaction?",
        answer: "We follow industry best practices, maintain open communication, and include review phases in every project to ensure you're satisfied with the outcome."
    },
    {
        question: "Is everything handled in-house or do you outsource?",
        answer: "Most of our work is handled in-house by our expert team. For specialized tasks, we may partner with trusted professionals under our direct supervision."
    },
    {
        question: "What makes you different from other service providers?",
        answer: "We focus on building long-term partnerships with our clients, offering personalized service, transparent pricing, and results-driven solutions."
    },
    {
        question: "What is your cancellation or refund policy?",
        answer: "We aim to be fair and transparent. Our policy includes partial refunds for unused work after proper conclusion with the client. No refunds are issued after a certain project stage."
    }
];


const Faq = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const breadcrumbLinks = [
        { label: 'Home', url: '/' },
        { label: 'Faqs' },
    ];

    return (
        <>
            <Breadcrumb pageTitle="Faqs" breadcrumbLinks={breadcrumbLinks} />

            <div className="faq-area pd-top-112">
                <div className="container">
                    <div className="row custom-gutters-60 justify-content-center">
                        <div className="col-xl-9 col-lg-11">
                            <div className="section-title text-center">
                                <h2 className="title">Frequently <span>Asked Questions</span></h2>
                            </div>

                            <div className="accordion" id="accordion">
                                {faqs.map((faq, index) => (
                                    <div className="single-accordion card" key={index}>
                                        <div className="card-header" id={`heading${index}`}>
                                            <h2 className="mb-0">
                                                <button
                                                    className={`btn btn-link ${activeIndex === index ? '' : 'collapsed'}`}
                                                    type="button"
                                                    onClick={() => toggleAccordion(index)}
                                                    aria-expanded={activeIndex === index}
                                                >
                                                    {faq.question}
                                                </button>
                                            </h2>
                                        </div>
                                        <div
                                            id={`collapse${index}`}
                                            className={`collapse ${activeIndex === index ? 'show' : ''}`}
                                            aria-labelledby={`heading${index}`}
                                        >
                                            <div className="card-body">
                                                {faq.answer}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

// Add Helmet for meta tags
const FaqWithHelmet = () => (
  <>
    <Helmet>
      <title>FAQ – Fusion Hub</title>
      <meta name="description" content="Find answers to frequently asked questions about Fusion Hub’s services, processes, and more." />
    </Helmet>
    <Faq />
  </>
);

export default FaqWithHelmet;
